goog.provide('el8.app.settings.genericOrder');

goog.require('el8.util.amplitude.helpers');

//
// The existing SleepOrder is being reskinned as a generic order
// This is hidden behind the 'GenericOrder' Feature.
//
// This file provides functions to return the proper label when
// the practice has the feature active. Generally, the label will
// be 'Order' for active and the previous 'Sleep Order' otherwise.
//

el8.app.settings.genericOrder = (function() {

    return {

        isFeatureActive: function() {
            if (el8Globals.FEATURES && el8Globals.FEATURES.GenericOrder) {
                return true;
            }
            return false;
        },

        sendToAmplitude: function() {
            //
            // logEvent() is probably not right.
            //
            // We need to log each time the SleepOrder is used and
            // each time the GenericOrder is used. The absence of a value
            // should NOT indicate the GenericOrder is NOT being used.
            //
            return true;
            //el8.util.amplitude.logEvent('Practice using generic order');
        },

        getLabel: function(featureActiveText, defaultText) {
            //
            //  Automatic determination between provided text to display
            //  if the GenericOrder feature is active, or provided default
            //  text for when it is not.
            //
            return this.isFeatureActive() ? featureActiveText : defaultText;
        },


    }
});